
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestpostagemeters",
      function () {
        return require("private-next-pages/bestpostagemeters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestpostagemeters"])
      });
    }
  